import { Zap, Droplets, Hammer, KeyRound, ArrowUpDown, Flame, Home, Sparkles, Leaf, Wrench, Building2, Waves, Scale, Antenna, Shield, Flame as FlameFire, Briefcase } from "lucide-react";

// Icona scarafaggio (lucide non la include): stile line-art coerente con lucide.
export const Cockroach = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="12" cy="13.5" rx="4" ry="6" />
    <circle cx="12" cy="5.5" r="1.8" />
    <path d="M11 4 L9 1.5 M13 4 L15 1.5" />
    <path d="M12 8 L12 19" />
    <path d="M8.2 10 L3.5 7.5 M8 13.5 L3 13.5 M8.2 17 L3.5 19.5" />
    <path d="M15.8 10 L20.5 7.5 M16 13.5 L21 13.5 M15.8 17 L20.5 19.5" />
  </svg>
);

const MAP = {
  "Elettrica": { icon: Zap, color: "text-yellow-500", bg: "bg-yellow-100" },
  "Idraulica": { icon: Droplets, color: "text-blue-600", bg: "bg-blue-100" },
  "Muraria": { icon: Hammer, color: "text-amber-700", bg: "bg-amber-100" },
  "Serramenti/Fabbro": { icon: KeyRound, color: "text-slate-600", bg: "bg-slate-200" },
  "Ascensore": { icon: ArrowUpDown, color: "text-teal-600", bg: "bg-teal-100" },
  "Antennista": { icon: Antenna, color: "text-fuchsia-600", bg: "bg-fuchsia-100" },
  "Riscaldamento/Caldaia": { icon: Flame, color: "text-red-600", bg: "bg-red-100" },
  "Tetto/Lattoneria": { icon: Home, color: "text-orange-700", bg: "bg-orange-100" },
  "Pulizie": { icon: Sparkles, color: "text-cyan-600", bg: "bg-cyan-100" },
  "Giardinaggio": { icon: Leaf, color: "text-green-600", bg: "bg-green-100" },
  "Assicurazione": { icon: Shield, color: "text-blue-700", bg: "bg-blue-100" },
  "Antincendio": { icon: FlameFire, color: "text-rose-600", bg: "bg-rose-100" },
  "Professionista": { icon: Briefcase, color: "text-stone-700", bg: "bg-stone-100" },
  "Studi Amministrazione": { icon: Building2, color: "text-violet-600", bg: "bg-violet-100" },
  "Avvocato-Studi Legali": { icon: Scale, color: "text-indigo-700", bg: "bg-indigo-100" },
  "Disinfestazioni": { icon: Cockroach, color: "text-emerald-600", bg: "bg-emerald-100" },
  "Spurghi": { icon: Waves, color: "text-sky-600", bg: "bg-sky-100" },
  "Altro": { icon: Wrench, color: "text-slate-500", bg: "bg-slate-100" },
};

export function CategoryIcon({ categoria, compact = false }) {
  const c = MAP[categoria] || MAP["Altro"];
  const Icon = c.icon;
  return (
    <span data-testid={`cat-icon-${categoria}`} title={categoria}
      className={`inline-flex items-center justify-center rounded-lg shrink-0 ${compact ? "p-1.5" : "p-2"} ${c.bg}`}>
      <Icon className={`${compact ? "w-4 h-4" : "w-5 h-5"} ${c.color}`} />
    </span>
  );
}
